module.exports = "https://cdn.realtymogul.com/static/media/up_blk.d4967bfc.svg";